// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics_panel__mAgxR {
  max-width: var(--page-max);
  margin-inline: auto;
  padding: 24px;
  color: var(--text);
}

/* ── toolbar: title + range filter ──────────────────────────────────────────── */
.analytics_toolbar__WWmqi {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

/* Sized to match the headings on the other report pages, so Analytics does not
   read as a lesser one. */
.analytics_eyebrow__1kwgC {
  font-size: var(--fs-10);
  font-weight: var(--fw-bold);
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 2px;
}
.analytics_title__mM9vM {
  margin: 0;
  font-size: var(--fs-28);
  font-weight: var(--fw-bold);
  letter-spacing: -0.4px;
  color: var(--text);
}

.analytics_subtitle__zHmZI {
  font-size: var(--fs-12);
  color: var(--text-muted-alt);
  margin-top: 4px;
}

.analytics_strong__HsEVz { color: var(--text); font-weight: var(--fw-semibold); }

.analytics_rangeControls__9YTZR {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.analytics_rangeBtns__MDRFa {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.analytics_customRange__ciDpW {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.analytics_dateInput__UYPRO {
  background: transparent;
  border: var(--hairline);
  color: var(--text);
  border-radius: var(--radius-8);
  padding: 6px 10px;
  font-family: inherit;
  font-size: var(--fs-12);
  color-scheme: dark;
}
.analytics_dateInput__UYPRO:focus {
  outline: none;
  border-color: var(--accent);
}
.analytics_dateDash__WeptB { color: var(--text-muted-alt); }

.analytics_rangeBtn__RL5vJ {
  /* Transparent on purpose. This class lives in analytics.module.css, whose
     light-mode scope is \`.light\`; the report pages wrap themselves in
     \`.lightPage\` from staff.module.css, which a selector written here cannot
     reach. Any solid background set here therefore shows its dark value on a
     light page. */
  background: transparent;
  border: var(--hairline);
  color: var(--accent);
  border-radius: var(--radius-8);
  padding: 7px 14px;
  font-family: inherit;
  font-size: var(--fs-12);
  font-weight: var(--fw-semibold);
  cursor: pointer;
}
.analytics_rangeBtn__RL5vJ:hover { border-color: var(--accent); color: var(--accent); }

.analytics_rangeBtnActive__fad45,
.analytics_rangeBtnActive__fad45:hover {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--surface-light-alt);
}

/* ── chart card ─────────────────────────────────────────────────────────────── */
.analytics_chartCard__CA0ns {
  border: var(--hairline);
  border-radius: var(--radius-12);
  background: var(--surface);
  padding: 16px;
  max-width: 960px;
  margin: auto;
}

.analytics_legend__DDCPo {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 8px;
}
.analytics_legendItem__8-Hyp {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.analytics_legendName__rXbQ- {
  font-size: var(--fs-12);
  color: #b8a898;
}

.analytics_chartWrap__E\\+SHb {
  position: relative;
  width: 100%;
}
.analytics_svg__flGLT {
  display: block;
  width: 100%;
  height: auto;
  touch-action: none;
}

/* ── hover tooltip ──────────────────────────────────────────────────────────── */
.analytics_tooltip__5fK\\+f {
  position: absolute;
  top: 8px;
  z-index: 5;
  min-width: 150px;
  pointer-events: none;
  background: var(--surface-sunken);
  border: var(--hairline);
  border-radius: var(--radius-8);
  padding: 8px 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
}
.analytics_tooltipDate__qCp6D {
  font-size: var(--fs-11);
  font-weight: var(--fw-bold);
  color: var(--text);
  margin-bottom: 6px;
}
.analytics_tooltipRow__H1l9e {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--fs-12);
  line-height: 1.6;
}
.analytics_tooltipTotal__Etnfr {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid var(--border);
  font-weight: var(--fw-bold);
}
.analytics_tooltipDot__6qbX6 {
  width: 9px;
  height: 9px;
  border-radius: var(--radius-2);
  flex-shrink: 0;
}
.analytics_tooltipName__PzKcO { color: #b8a898; flex: 1 1; }
.analytics_tooltipVal__LwDxG { color: var(--text); font-variant-numeric: tabular-nums; }

.analytics_state__pQTbm {
  padding: 48px 16px;
  text-align: center;
  color: var(--text-muted-alt);
  font-size: var(--fs-13);
}
.analytics_retry__Vi\\+rb {
  background: transparent;
  border: var(--hairline);
  color: var(--accent);
  border-radius: var(--radius-6);
  padding: 4px 10px;
  font-family: inherit;
  font-size: var(--fs-12);
  cursor: pointer;
  margin-left: 6px;
}
.analytics_fetching__Z7TbA {
  font-size: var(--fs-11);
  color: var(--text-muted-alt);
  text-align: right;
  margin-top: 4px;
}

/* ── data table ─────────────────────────────────────────────────────────────── */
.analytics_tableWrap__mT\\+9k {
  margin-top: 20px;
  border: var(--hairline);
  border-radius: var(--radius-12);
  overflow: auto;
  max-height: 680px;
}
.analytics_table__ui4L3 {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-13);
}
.analytics_table__ui4L3 th {
  position: sticky;
  top: 0;
  text-align: left;
  padding: 10px 14px;
  background: var(--surface);
  color: var(--text-muted-alt);
  font-weight: var(--fw-semibold);
  font-size: var(--fs-11);
  letter-spacing: 1px;
  text-transform: uppercase;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}
.analytics_table__ui4L3 th.analytics_num__OM82j {
  text-align: right;
}
.analytics_table__ui4L3 td {
  padding: 9px 14px;
  border-bottom: 1px solid #1a1815;
  color: var(--text);
  white-space: nowrap;
}
.analytics_table__ui4L3 tbody tr:hover td { background: rgba(201, 149, 106, 0.06); }
.analytics_num__OM82j {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.analytics_table__ui4L3 tfoot td {
  position: sticky;
  bottom: 0;
  background: var(--surface);
  border-top: 1px solid var(--border);
  border-bottom: none;
  color: var(--text);
}

/* ── light mode ─────────────────────────────────────────────────────────────── */
.analytics_light__NJ4vZ { color: var(--text-on-light); }
.analytics_light__NJ4vZ .analytics_title__mM9vM { color: var(--text-on-light); }
.analytics_light__NJ4vZ .analytics_subtitle__zHmZI { color: var(--text-muted-on-light); }
.analytics_light__NJ4vZ .analytics_eyebrow__1kwgC  { color: var(--text-muted-on-light); }
.analytics_light__NJ4vZ .analytics_title__mM9vM    { color: var(--text-on-light); }
.analytics_light__NJ4vZ .analytics_strong__HsEVz { color: var(--text-on-light); }

.analytics_light__NJ4vZ .analytics_rangeBtn__RL5vJ {
  border-color: var(--border-light);
  color: var(--text-on-light);
}
.analytics_light__NJ4vZ .analytics_rangeBtn__RL5vJ:hover { border-color: var(--accent-strong); color: var(--accent-strong); }
.analytics_light__NJ4vZ .analytics_rangeBtnActive__fad45,
.analytics_light__NJ4vZ .analytics_rangeBtnActive__fad45:hover {
  background: var(--accent-strong);
  border-color: var(--accent-strong);
  color: var(--surface-light-alt);
}

.analytics_light__NJ4vZ .analytics_dateInput__UYPRO {
  border-color: var(--border-light);
  color: var(--text-on-light);
  color-scheme: light;
}
.analytics_light__NJ4vZ .analytics_dateInput__UYPRO:focus { border-color: var(--accent-strong); }
.analytics_light__NJ4vZ .analytics_dateDash__WeptB { color: var(--text-muted-on-light); }

.analytics_light__NJ4vZ .analytics_chartCard__CA0ns {
  border-color: var(--border-light);
  background: var(--surface-light);
}
.analytics_light__NJ4vZ .analytics_legendName__rXbQ- { color: #6a5c4e; }

.analytics_light__NJ4vZ .analytics_tooltip__5fK\\+f {
  background: var(--surface-light);
  border-color: var(--border-light);
  box-shadow: 0 6px 18px rgba(120, 100, 80, 0.18);
}
.analytics_light__NJ4vZ .analytics_tooltipDate__qCp6D { color: var(--text-on-light); }
.analytics_light__NJ4vZ .analytics_tooltipTotal__Etnfr { border-top-color: #e8e0d4; }
.analytics_light__NJ4vZ .analytics_tooltipName__PzKcO { color: #6a5c4e; }
.analytics_light__NJ4vZ .analytics_tooltipVal__LwDxG { color: var(--text-on-light); }

.analytics_light__NJ4vZ .analytics_state__pQTbm,
.analytics_light__NJ4vZ .analytics_fetching__Z7TbA { color: var(--text-muted-on-light); }

.analytics_light__NJ4vZ .analytics_tableWrap__mT\\+9k { border-color: var(--border-light); }
.analytics_light__NJ4vZ .analytics_table__ui4L3 th {
  background: var(--surface-light-background);
  color: var(--text-muted-on-light);
  border-bottom-color: var(--border-light);
}
.analytics_light__NJ4vZ .analytics_table__ui4L3 td {
  color: var(--text-on-light);
  border-bottom-color: #e8e0d4;
}
.analytics_light__NJ4vZ .analytics_table__ui4L3 tbody tr:hover td { background: rgba(176, 120, 64, 0.07); }
.analytics_light__NJ4vZ .analytics_table__ui4L3 tfoot td {
  background: var(--surface-light-background);
  border-top-color: var(--border-light);
  color: var(--text-on-light);
}
`, "",{"version":3,"sources":["webpack://./src/styles/analytics.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;0BAC0B;AAC1B;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,2BAAU,kBAAkB,EAAE,+BAA+B,EAAE;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA,6BAAY,4BAA4B,EAAE;;AAE1C;EACE;;;;kBAIgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;AACA,mCAAkB,2BAA2B,EAAE,oBAAoB,EAAE;;AAErE;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,kFAAkF;AAClF;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;AACA,gCAAe,cAAc,EAAE,SAAO,EAAE;AACxC,+BAAc,kBAAkB,EAAE,kCAAkC,EAAE;;AAEtE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;AACA,4CAA2B,qCAAqC,EAAE;AAClE;EACE,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF,0BAAS,2BAA2B,EAAE;AACtC,kDAAgB,2BAA2B,EAAE;AAC7C,qDAAmB,iCAAiC,EAAE;AACtD,qDAAmB,iCAAiC,EAAE;AACtD,qDAAmB,2BAA2B,EAAE;AAChD,mDAAiB,2BAA2B,EAAE;;AAE9C;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;AACA,2DAAyB,kCAAkC,EAAE,2BAA2B,EAAE;AAC1F;;EAEE,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;AACrB;AACA,4DAA0B,kCAAkC,EAAE;AAC9D,qDAAmB,iCAAiC,EAAE;;AAEtD;EACE,iCAAiC;EACjC,gCAAgC;AAClC;AACA,uDAAqB,cAAc,EAAE;;AAErC;EACE,gCAAgC;EAChC,iCAAiC;EACjC,+CAA+C;AACjD;AACA,wDAAsB,2BAA2B,EAAE;AACnD,yDAAuB,yBAAyB,EAAE;AAClD,wDAAsB,cAAc,EAAE;AACtC,uDAAqB,2BAA2B,EAAE;;AAElD;qDACmB,iCAAiC,EAAE;;AAEtD,uDAAoB,iCAAiC,EAAE;AACvD;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,wCAAwC;AAC1C;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA,oEAAkC,oCAAoC,EAAE;AACxE;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,2BAA2B;AAC7B","sourcesContent":[".panel {\n  max-width: var(--page-max);\n  margin-inline: auto;\n  padding: 24px;\n  color: var(--text);\n}\n\n/* ── toolbar: title + range filter ──────────────────────────────────────────── */\n.toolbar {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n/* Sized to match the headings on the other report pages, so Analytics does not\n   read as a lesser one. */\n.eyebrow {\n  font-size: var(--fs-10);\n  font-weight: var(--fw-bold);\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 2px;\n}\n.title {\n  margin: 0;\n  font-size: var(--fs-28);\n  font-weight: var(--fw-bold);\n  letter-spacing: -0.4px;\n  color: var(--text);\n}\n\n.subtitle {\n  font-size: var(--fs-12);\n  color: var(--text-muted-alt);\n  margin-top: 4px;\n}\n\n.strong { color: var(--text); font-weight: var(--fw-semibold); }\n\n.rangeControls {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.rangeBtns {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.customRange {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.dateInput {\n  background: transparent;\n  border: var(--hairline);\n  color: var(--text);\n  border-radius: var(--radius-8);\n  padding: 6px 10px;\n  font-family: inherit;\n  font-size: var(--fs-12);\n  color-scheme: dark;\n}\n.dateInput:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n.dateDash { color: var(--text-muted-alt); }\n\n.rangeBtn {\n  /* Transparent on purpose. This class lives in analytics.module.css, whose\n     light-mode scope is `.light`; the report pages wrap themselves in\n     `.lightPage` from staff.module.css, which a selector written here cannot\n     reach. Any solid background set here therefore shows its dark value on a\n     light page. */\n  background: transparent;\n  border: var(--hairline);\n  color: var(--accent);\n  border-radius: var(--radius-8);\n  padding: 7px 14px;\n  font-family: inherit;\n  font-size: var(--fs-12);\n  font-weight: var(--fw-semibold);\n  cursor: pointer;\n}\n.rangeBtn:hover { border-color: var(--accent); color: var(--accent); }\n\n.rangeBtnActive,\n.rangeBtnActive:hover {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--surface-light-alt);\n}\n\n/* ── chart card ─────────────────────────────────────────────────────────────── */\n.chartCard {\n  border: var(--hairline);\n  border-radius: var(--radius-12);\n  background: var(--surface);\n  padding: 16px;\n  max-width: 960px;\n  margin: auto;\n}\n\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n.legendItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.legendName {\n  font-size: var(--fs-12);\n  color: #b8a898;\n}\n\n.chartWrap {\n  position: relative;\n  width: 100%;\n}\n.svg {\n  display: block;\n  width: 100%;\n  height: auto;\n  touch-action: none;\n}\n\n/* ── hover tooltip ──────────────────────────────────────────────────────────── */\n.tooltip {\n  position: absolute;\n  top: 8px;\n  z-index: 5;\n  min-width: 150px;\n  pointer-events: none;\n  background: var(--surface-sunken);\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  padding: 8px 10px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);\n}\n.tooltipDate {\n  font-size: var(--fs-11);\n  font-weight: var(--fw-bold);\n  color: var(--text);\n  margin-bottom: 6px;\n}\n.tooltipRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--fs-12);\n  line-height: 1.6;\n}\n.tooltipTotal {\n  margin-top: 4px;\n  padding-top: 4px;\n  border-top: 1px solid var(--border);\n  font-weight: var(--fw-bold);\n}\n.tooltipDot {\n  width: 9px;\n  height: 9px;\n  border-radius: var(--radius-2);\n  flex-shrink: 0;\n}\n.tooltipName { color: #b8a898; flex: 1; }\n.tooltipVal { color: var(--text); font-variant-numeric: tabular-nums; }\n\n.state {\n  padding: 48px 16px;\n  text-align: center;\n  color: var(--text-muted-alt);\n  font-size: var(--fs-13);\n}\n.retry {\n  background: transparent;\n  border: var(--hairline);\n  color: var(--accent);\n  border-radius: var(--radius-6);\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: var(--fs-12);\n  cursor: pointer;\n  margin-left: 6px;\n}\n.fetching {\n  font-size: var(--fs-11);\n  color: var(--text-muted-alt);\n  text-align: right;\n  margin-top: 4px;\n}\n\n/* ── data table ─────────────────────────────────────────────────────────────── */\n.tableWrap {\n  margin-top: 20px;\n  border: var(--hairline);\n  border-radius: var(--radius-12);\n  overflow: auto;\n  max-height: 680px;\n}\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--fs-13);\n}\n.table th {\n  position: sticky;\n  top: 0;\n  text-align: left;\n  padding: 10px 14px;\n  background: var(--surface);\n  color: var(--text-muted-alt);\n  font-weight: var(--fw-semibold);\n  font-size: var(--fs-11);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n}\n.table th.num {\n  text-align: right;\n}\n.table td {\n  padding: 9px 14px;\n  border-bottom: 1px solid #1a1815;\n  color: var(--text);\n  white-space: nowrap;\n}\n.table tbody tr:hover td { background: rgba(201, 149, 106, 0.06); }\n.num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n.table tfoot td {\n  position: sticky;\n  bottom: 0;\n  background: var(--surface);\n  border-top: 1px solid var(--border);\n  border-bottom: none;\n  color: var(--text);\n}\n\n/* ── light mode ─────────────────────────────────────────────────────────────── */\n.light { color: var(--text-on-light); }\n.light .title { color: var(--text-on-light); }\n.light .subtitle { color: var(--text-muted-on-light); }\n.light .eyebrow  { color: var(--text-muted-on-light); }\n.light .title    { color: var(--text-on-light); }\n.light .strong { color: var(--text-on-light); }\n\n.light .rangeBtn {\n  border-color: var(--border-light);\n  color: var(--text-on-light);\n}\n.light .rangeBtn:hover { border-color: var(--accent-strong); color: var(--accent-strong); }\n.light .rangeBtnActive,\n.light .rangeBtnActive:hover {\n  background: var(--accent-strong);\n  border-color: var(--accent-strong);\n  color: var(--surface-light-alt);\n}\n\n.light .dateInput {\n  border-color: var(--border-light);\n  color: var(--text-on-light);\n  color-scheme: light;\n}\n.light .dateInput:focus { border-color: var(--accent-strong); }\n.light .dateDash { color: var(--text-muted-on-light); }\n\n.light .chartCard {\n  border-color: var(--border-light);\n  background: var(--surface-light);\n}\n.light .legendName { color: #6a5c4e; }\n\n.light .tooltip {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n  box-shadow: 0 6px 18px rgba(120, 100, 80, 0.18);\n}\n.light .tooltipDate { color: var(--text-on-light); }\n.light .tooltipTotal { border-top-color: #e8e0d4; }\n.light .tooltipName { color: #6a5c4e; }\n.light .tooltipVal { color: var(--text-on-light); }\n\n.light .state,\n.light .fetching { color: var(--text-muted-on-light); }\n\n.light .tableWrap { border-color: var(--border-light); }\n.light .table th {\n  background: var(--surface-light-background);\n  color: var(--text-muted-on-light);\n  border-bottom-color: var(--border-light);\n}\n.light .table td {\n  color: var(--text-on-light);\n  border-bottom-color: #e8e0d4;\n}\n.light .table tbody tr:hover td { background: rgba(176, 120, 64, 0.07); }\n.light .table tfoot td {\n  background: var(--surface-light-background);\n  border-top-color: var(--border-light);\n  color: var(--text-on-light);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `analytics_panel__mAgxR`,
	"toolbar": `analytics_toolbar__WWmqi`,
	"eyebrow": `analytics_eyebrow__1kwgC`,
	"title": `analytics_title__mM9vM`,
	"subtitle": `analytics_subtitle__zHmZI`,
	"strong": `analytics_strong__HsEVz`,
	"rangeControls": `analytics_rangeControls__9YTZR`,
	"rangeBtns": `analytics_rangeBtns__MDRFa`,
	"customRange": `analytics_customRange__ciDpW`,
	"dateInput": `analytics_dateInput__UYPRO`,
	"dateDash": `analytics_dateDash__WeptB`,
	"rangeBtn": `analytics_rangeBtn__RL5vJ`,
	"rangeBtnActive": `analytics_rangeBtnActive__fad45`,
	"chartCard": `analytics_chartCard__CA0ns`,
	"legend": `analytics_legend__DDCPo`,
	"legendItem": `analytics_legendItem__8-Hyp`,
	"legendName": `analytics_legendName__rXbQ-`,
	"chartWrap": `analytics_chartWrap__E+SHb`,
	"svg": `analytics_svg__flGLT`,
	"tooltip": `analytics_tooltip__5fK+f`,
	"tooltipDate": `analytics_tooltipDate__qCp6D`,
	"tooltipRow": `analytics_tooltipRow__H1l9e`,
	"tooltipTotal": `analytics_tooltipTotal__Etnfr`,
	"tooltipDot": `analytics_tooltipDot__6qbX6`,
	"tooltipName": `analytics_tooltipName__PzKcO`,
	"tooltipVal": `analytics_tooltipVal__LwDxG`,
	"state": `analytics_state__pQTbm`,
	"retry": `analytics_retry__Vi+rb`,
	"fetching": `analytics_fetching__Z7TbA`,
	"tableWrap": `analytics_tableWrap__mT+9k`,
	"table": `analytics_table__ui4L3`,
	"num": `analytics_num__OM82j`,
	"light": `analytics_light__NJ4vZ`
};
export default ___CSS_LOADER_EXPORT___;
